import './Hero.css';
import { NavLink } from "react-router-dom";

export default function Hero() {
    return (
        <section className="hero-container">
            <div className="hero-overlay"></div>

            <div className="hero-content">
                <h1 className="hero-title">PIZZERIA A CECINA</h1>

                <div className="hero-badge">
                    <span>PIZZA</span>
                    <span>•</span>
                    <span>SCHIACCIATINO</span>
                    <span>•</span>
                    <span>BIRRA</span>
                </div>

                <p className="hero-subtitle">
                    Pizza croccante, impasto leggero e forno rovente.
                </p>

                <NavLink className="hero-button" to="/menu">SCOPRI IL MENU</NavLink>
            </div>
        </section>
    );
}
